<input
  type="text"
  class="form-control"
  [placeholder]="placeholder"
  [class.has-addon]="hasAddon"
  [class.placeholder-hidden]="placeholderHidden"
  [min]="min"
  [max]="max"
  [maxlength]="maxLength"
  appNaturalNumberValidator
  [required]="required"
  [name]="$any(name)"
  [id]="name"
  [disabled]="disabled"
  [appIsEnabled]="appIsEnabled"
  (keydown)="onKeyDown($event)"
  (blur)="onBlur()"
  (onValidated)="onValidated($event)"
  (change)="onChange($event)"
  [(ngModel)]="value"
  />
<ng-content select=".form-group-input-label"></ng-content>
<div>
  <!--
  this empty div is required (so that the input is not the first and last element inside the
  app-natural-number-input tag) to trick bootstrap so it does not remove border radius
  from the input's left side in case it is used in an input group with a button attached
--></div>
<ng-template #errorsTemplate>
  @if (errors && errors.required) {
    <div>Missing value or invalid format</div>
  }
  @if (errors && errors.negative) {
    <div>The value should be a non-negative number</div>
  }
  @if (errors && errors.notInteger) {
    <div>The value should be a number</div>
  }
  @if (errors && errors.min) {
    <div>Minimum allowed value is {{ this.min }}.</div>
  }
  @if (errors && errors.max) {
    <div>Maximum allowed value is {{ this.max }}.</div>
  }
  @if (errors && errors.maxlength) {
    <div>The value may only contain up to {{ this.maxLength }} digits.</div>
  }
  @if (backendValidationError) {
    <div>
      {{ backendValidationError }}
    </div>
  }
</ng-template>
